import { useQuery } from '@tanstack/react-query';
import { allocationQueries } from '../queries';
import type { ContractSearchParams } from '../types/Filters';

export function useContracts(search: string, params?: ContractSearchParams) {
  return useQuery(allocationQueries.contracts(search, params));
}
